/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { get, keys } from 'lodash';
import {
  IonContent,
  IonList,
  IonItem,
} from '@ionic/react';
import { colors } from 'kards-components';
import { useHistory } from 'react-router-dom';

import { ThemeContext } from '../../card/context/theme';
import { questions } from './HelpsDetail';


const IonItemWrapper = styled(IonItem)`
  --inner-border-width: 0;
  --border-width: 0;
  --inner-padding-top: 0;
  --inner-padding-bottom: 0;
  width: 95%;
`;

const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: ${(props) => props.borderBottom};
  border-top: ${(props) => props.borderTop};
  --inner-border-width: 0;
  padding-bottom: .8em;
  padding-top: .8em;
`;

const Help = () => {
  const {
    theme,
  }: any = useContext(ThemeContext);
  const history = useHistory();

  return (
    <IonContent color={get(theme, 'color.background')}>
      <IonList style={{ padding: '1em 0', background: colors[get(theme, 'color.background')] }}>
        {keys(questions).map(number => (
          <IonItemWrapper onClick={() => history.push(`/menu/help/${number}`)} lines="inset" color={get(theme, 'color.background')}>
            <RowWrapper color={colors[get(theme, 'color.title')]}>
              {questions[number]}
            </RowWrapper>
          </IonItemWrapper>
        ))}
      </IonList>
    </IonContent>
  );
};

export default Help;
